module.exports = __webpack_public_path__ + "back.png?237862dacda45065375b19e875b15163";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/back.png
// module id = 1
// module chunks = 0